@if (iconClass) {
  <dcr-icon class="campus-icon" [attr.icon]="iconClass"></dcr-icon>
  } <ng-content></ng-content>
